import "./SwipeableModals.scss";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { Rating } from "@mui/material";
import ShopPhoto from "./../../../assets/shop-img.png";
import ProductPhoto from "./../../../assets/product-img.png";
import StarIcon from "@mui/icons-material/Star";

const SwipeableModals = ({ open, onClose, onOpen, currentView }) => {
  const renderUserRatesView = () => (
    <div className="user-modal">
      <p className="user-modal-p">عرض التقييم</p>

      <div className="shop">
        <p className="title">المتجر</p>
        <div className="img-container">
          <img src={ShopPhoto} alt="" />
          <p className="name">بلاك اوت للملابس</p>
        </div>
        <Rating
          name="text-feedback"
          value={4}
          readOnly
          precision={0.5}
          emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="10px" />}
        />
        <p className="rate-text">
          لوريم إيبسوم طريقة لكتابة النصوص في النشر والتصميم الجرافيكي تستخدم
          بشكل شائع لتوضيح الشكل المرئي للمستند أو الخط دون الاعتماد على محتوى
          ذي معنى. يمكن استخدام لوريم إيبسوم قبل نشر النسخة النهائية
        </p>
      </div>

      <div className="shop">
        <p className="title">المنتج</p>
        <div className="img-container">
          <img src={ProductPhoto} alt="" />
          <p className="name">موبايل سامسونج جالاكسي بشريحتين اتصال</p>
        </div>
        <Rating
          name="text-feedback"
          value={4}
          readOnly
          precision={0.5}
          emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="10px" />}
        />
        <p className="rate-text">
          لوريم إيبسوم طريقة لكتابة النصوص في النشر والتصميم الجرافيكي تستخدم
          بشكل شائع لتوضيح الشكل المرئي للمستند أو الخط دون الاعتماد على محتوى
          ذي معنى. يمكن استخدام لوريم إيبسوم قبل نشر النسخة النهائية
        </p>
      </div>
    </div>
  );

  const renderDefaultView = () => <div></div>;

  const views = {
    userRates: renderUserRatesView,
  };

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{ zIndex: "1202" }}
      disableScrollLock
    >
      {(views[currentView] || renderDefaultView)()}
    </SwipeableDrawer>
  );
};

export default SwipeableModals;
